export default __webpack_public_path__ + "images/9f905095839418bdf7b6a99368cd6ca5.svg";